import { Title, Grid, Stack, Flex, Tooltip, Group } from "@mantine/core";
import { ContainerWhite } from "../../components/core";
import {
  AfaAlert,
  AfaAnchor,
  AfaButton,
  AfaAvisosTerminisCard,
  AfaComunicacionsCard,
  AfaModal,
  AfaTextInput,
  AfaDatePickerInput,
  AfaMessageAnime,
  AfaPageLoader,
  AfaSectionLoader,
} from "../../components/ui";
import { IconInfoCircle } from "@tabler/icons-react";
import { useNavigate, useLocation } from "react-router-dom";
import { useState, useMemo, useEffect } from "react";
import { AfaTable } from "../../components/ui/AfaTable/AfaTable";
import { getTramesesColumns } from "../../config/tramesesTableConfig";
import { getTramitsColumns } from "../../config/tramitsTableConfig";
import { CancelTramesaModal } from "../../components/Modals/CancelTramesaModal/CancelTramesaModal";
import moment from "moment";
import { CancelTramitModal } from "../../components/Modals/CancelTramitModal/CancelTramitModal";

const filterUrgentTrameses = (
  tramesesData: any[],
  tramesesEntregadas: any[] = [],
) => {
  const entregasMap = new Map(
    tramesesEntregadas.map((e) => [e.tramesaType.lookupValue.trim(), e]),
  );

  const hoy = new Date();

  const result: Array<{
    id: any;
    itemType: string;
    typeName: string;
    estat: string;
    dateTermini: string;
  }> = [];

  tramesesData.forEach((tramesa) => {
    const entrega = entregasMap.get(tramesa.titulo.trim());

    if (Array.isArray(tramesa.fechasLimite)) {
      tramesa.fechasLimite.forEach((fecha: any) => {
        const fechaLimite = new Date(fecha.fechaLimiteEntrega);
        if (isNaN(fechaLimite.getTime())) return;

        let estadoFecha = "Pendent";

        if (entrega) {
          const rawState = entrega.state?.trim() || "";
          if (rawState === "Finalitzat") {
            estadoFecha = "Rebut";
          } else if (
            rawState === "En revisió" ||
            rawState === "Pendent rebre documentació"
          ) {
            estadoFecha = "Enviat";
          } else {
            estadoFecha = "Rebut";
          }
        } else if (fechaLimite < hoy) {
          estadoFecha = "No rebut";
        }

        const diffDias = Math.ceil(
          (fechaLimite.getTime() - hoy.getTime()) / (1000 * 60 * 60 * 24),
        );

        // Filtrar solo si estado es 'No rebut' o 'Pendent' y faltan menos de 7 días
        if (
          (estadoFecha === "No rebut" || estadoFecha === "Pendent") &&
          diffDias <= 7
        ) {
          result.push({
            id: tramesa.Id || tramesa.id,
            itemType: "Tramesa",
            typeName: "Tramesa - " + tramesa.titulo + " " + fecha.periodo,
            estat: estadoFecha,
            dateTermini: fechaLimite.toLocaleDateString("ca-ES"),
          });
        }
      });
    }
  });

  return result;
};

const Dashboard = (props: any) => {
  const navigate = useNavigate();

  const [cancelModalOpened, setCancelModalOpened] = useState<boolean>(false);
  const [cancelTramitModalOpened, setCancelTramitModalOpened] =
    useState<boolean>(false);

  // const tramitsData = useTramitsData({ excludeFinalitzat: true, limit: 5 });
  // const [filtresModalOpened, setFiltresModalOpened] = useState(false);
  // const [searchText, setSearchText] = useState('');
  // const [dataLimitDes, setDataLimitDes] = useState<Date | null>(null);
  // const [dataLimitFins, setDataLimitFins] = useState<Date | null>(null);

  const [tramesesData, setTramesesData] = useState([] as any[]);
  const [tramitsData, setTramitsData] = useState([] as any[]);
  const [comunicacionsData, setComunicacionsData] = useState([] as any[]);
  const [tramesesLoading, setTramesesLoading] = useState(true);
  const [tramitsLoading, setTramitsLoading] = useState(true);
  const [avisosLoading, setAvisosLoading] = useState(true);
  const [comunicacionsLoading, setComunicacionsLoading] = useState(true);
  const [selectedTramesaId, setSelectedTramesaId] = useState<string>("");
  const [selectedTramitId, setSelectedTramitId] = useState<string>("");
  const [filteredAvisos, setFilteredAvisos] = useState([] as any[]);
  const [filteredAvisos2, setFilteredAvisos2] = useState([] as any[]);

  // // Efecto para abrir el modal automáticamente si vienes desde home
  // useEffect(() => {
  //   // Verificar si el state contiene la información de que vienes desde home
  //   if (location.state?.fromHome) {
  //     setCambiarEntitatModalOpened(true);
  //     // Limpiar el state para que no se abra en futuras visitas
  //     window.history.replaceState({}, document.title);
  //   }
  // }, [location]);

  // Efecto para simular carga inicial del dashboard
  useEffect(() => {
    setTramesesLoading(true);
    setTramitsLoading(true);
    setAvisosLoading(true);
    setComunicacionsLoading(true);
  }, [props.entity]);

  useEffect(() => {
    if (tramitsLoading == true) {
      props.apiService
        .GetTramitsDashboard(props.entity.lookupId)
        .then((response: any) => {
          setTramitsData(response);
          setTramitsLoading(false);
        })
        .catch((error: any) => {
          setTramitsLoading(false);
          console.error("An error has occurred: " + error);
        });
    }
  }, [cancelTramitModalOpened]);

  useEffect(() => {
    getAvisosData();

    props.apiService
      .GetTramesesDashboard(props.entity.lookupId)
      .then((response: any) => {
        setTramesesData(response);
        setTramesesLoading(false);
      })
      .catch((error: any) => {
        setTramesesLoading(false);
        console.error("An error has occurred: " + error);
      });

    props.apiService
      .GetTramitsDashboard(props.entity.lookupId)
      .then((response: any) => {
        setTramitsData(response);
        setTramitsLoading(false);
      })
      .catch((error: any) => {
        setTramitsLoading(false);
        console.error("An error has occurred: " + error);
      });

    props.apiService
      .GetPendingItems("entityId", props.entity.lookupId)
      .then((response: any) => {
        setFilteredAvisos([...filteredAvisos, ...response]);
        setAvisosLoading(false);
      })
      .catch((error: any) => {
        setAvisosLoading(false);
        console.error("An error has occurred: " + error);
      });

    props.apiService
      .GetComunicaciones()
      .then((data: any) => {
        const oneYearAgo = new Date();
        oneYearAgo.setDate(oneYearAgo.getDate() - 365);

        // Filtrar los mensajes dentro de los últimos 365 días
        const recentMessages = data.filter((message: any) => {
          const messageDate = new Date(message.communicationDate);
          return messageDate >= oneYearAgo;
        });

        setComunicacionsData(recentMessages);
        setComunicacionsLoading(false);
      })
      .catch((error: any) => {
        console.error("Error fetching comunicaciones:", error);
        setComunicacionsLoading(false);
      });
  }, [props.entity]);

  const getAvisosData = () => {
    props.apiService
      .GetTramesesControl("entityId=" + props.entity.lookupId)
      .then((response: any) => {
        props.apiService
          .GetTrameses(props.entity.lookupId)
          .then((response2: any) => {
            response2 = response2.filter((item: any) => {
              return (
                item.state !== "Esborrany" &&
                item.state !== "Rebutjat AFA" &&
                item.state !== "Cancel·lat entitat"
              );
            });
            const tramesesCombinadas = response.map((tramesa: any) => {
              const entrega = response2.find(
                (e: any) =>
                  e.tramesaType.lookupValue.trim() === tramesa.titulo.trim(),
              );

              return {
                ...tramesa,
                estat: entrega ? entrega.state || "Rebut" : "No rebut",
                entregaId: entrega?.id || null,
              };
            });
            const transformed: any[] = filterUrgentTrameses(
              tramesesCombinadas,
              response2,
            );
            setFilteredAvisos2(transformed);
            setAvisosLoading(false);
          });
      })
      .catch((error: any) => {
        console.error("An error has occurred: " + error);
      });
  };

  // Estado para los avisos filtrados

  // Handlers para la tabla
  const tramesesHandlers: any = {
    onCancelTramesa: (tramesaId: string) => {
      setSelectedTramesaId(tramesaId);
      setCancelModalOpened(true);
    },
    onDeleteDraft: (tramesaId: string) => {
      setSelectedTramesaId(tramesaId);
      setCancelModalOpened(true);
    },
  };

  // Handlers para la tabla de tramits
  const tramitsHandlers = {
    onCancelTramit: (tramitId: string) => {
      setSelectedTramitId(tramitId);
      setCancelTramitModalOpened(true);
    },
    onDeleteDraft: (tramitId: string) => {
      setSelectedTramitId(tramitId);
      setCancelTramitModalOpened(true);
    },
  };

  // Obtener columnas de las tablas
  const tramesesColumns = getTramesesColumns(
    navigate,
    tramesesHandlers,
    props.user,
  );
  const tramitsColumns = getTramitsColumns(
    navigate,
    tramitsHandlers,
    props.user,
  );

  // const handleEntityChange = () => {
  //   setCambiarEntitatModalOpened(true);
  // };

  // Verificar si hay filtros aplicados
  // const hasActiveFilters = useMemo(() => {
  //   return searchText.trim() !== '' || dataLimitDes !== null || dataLimitFins !== null;
  // }, [searchText, dataLimitDes, dataLimitFins]);

  // const handleClearFilters = () => {
  //   setSearchText('');
  //   setDataLimitDes(null);
  //   setDataLimitFins(null);
  //   setFilteredAvisos(AVISOS_TERMINIS_DATA);
  // };

  // const handleSearch = () => {
  //   let filtered = [...AVISOS_TERMINIS_DATA];

  //   // Filtrar por texto de búsqueda
  //   if (searchText.trim()) {
  //     filtered = filtered.filter(aviso =>
  //       aviso.title.toLowerCase().includes(searchText.toLowerCase())
  //     );
  //   }

  //   // Filtrar por rango de fechas
  //   if (dataLimitDes || dataLimitFins) {
  //     filtered = filtered.filter(aviso => {
  //       const parts = aviso.dataLimit.split('/').map(Number);
  //       const day = parts[0] || 1;
  //       const month = parts[1] || 1;
  //       const year = parts[2] || new Date().getFullYear();
  //       const avisoDate = new Date(year, month - 1, day);
  //       avisoDate.setHours(0, 0, 0, 0);

  //       // Filtrar por fecha desde
  //       if (dataLimitDes) {
  //         const desde = new Date(dataLimitDes);
  //         desde.setHours(0, 0, 0, 0);
  //         if (avisoDate < desde) return false;
  //       }

  //       // Filtrar por fecha hasta
  //       if (dataLimitFins) {
  //         const fins = new Date(dataLimitFins);
  //         fins.setHours(0, 0, 0, 0);
  //         if (avisoDate > fins) return false;
  //       }

  //       return true;
  //     });
  //   }

  //   // setFilteredAvisos(filtered);
  //   setFiltresModalOpened(false);
  // };

  return (
    <Stack>
      <Title order={1}>Dashboard</Title>

      <Stack gap="xl">
        {/* Primera sección: 2 columnas (50% / 50%) */}
        <Grid gutter="xl" style={{ height: "450px" }}>
          <Grid.Col span={6}>
            <Stack gap="xs">
              {props.showAlerts && (
                <AfaAlert
                  type="warning"
                  variant="light"
                  title="Dades per Entitats"
                  withCloseButton={true}
                >
                  Les dades mostrades a tota la plataforma estan sota l'Entitat{" "}
                  <b>"{props.entity.lookupValue}"</b>. Si el teu usuari/rol té
                  accés a informació de més d'una entitat, pots alternar entre
                  elles al teu nom a la barra de menú del costat dret.
                </AfaAlert>
              )}
              <Flex justify="space-between" align="center" mt={"xs"}>
                <Title order={3}>Avisos i terminis propers</Title>
              </Flex>
              <ContainerWhite
                style={{
                  height: props.showAlerts ? "270px" : "400px",
                  overflowY: "auto",
                }}
              >
                {avisosLoading ? (
                  <AfaSectionLoader message="Carregant avisos i terminis..." />
                ) : (
                  <Stack gap="4px">
                    {filteredAvisos.length > 0
                      ? filteredAvisos.map((aviso: any) => (
                          <AfaAvisosTerminisCard
                            key={aviso.id}
                            title={aviso.itemType + " - " + aviso.typeName}
                            dataLimit={moment(aviso.dateTermini).format(
                              "DD/MM/YYYY",
                            )}
                            onClick={() => {
                              if (aviso.itemType == "Tramesa") {
                                navigate("/trameses/detall/" + aviso.id);
                              } else {
                                navigate("/tramits/detall/" + aviso.id);
                              }
                            }}
                            estat={aviso.estat}
                          />
                        ))
                      : null}

                    {filteredAvisos2.length > 0
                      ? filteredAvisos2.map((aviso: any) => (
                          <AfaAvisosTerminisCard
                            // key={aviso.id}
                            title={aviso.typeName}
                            dataLimit={aviso.dateTermini}
                            onClick={() => {
                              const match = aviso.typeName.match(/(\d{2})\/(\d{4})$/);

                              const mes = match ? match[1] : '';
                              const any = match ? match[2] : '';

                              navigate('/trameses/iniciar-nova', {
                                state: {
                                  TipologiaEntitat: aviso.itemType,
                                  TipologiaTramesa: aviso.id,
                                  periodoTramesa: mes,
                                  anyOptions: any,
                                  DefaultEntity : true
                                },
                              });
                            }}
                            estat={aviso.estat}
                          />
                        ))
                      : null}
                    {filteredAvisos.length === 0 &&
                    filteredAvisos2.length === 0 ? (
                      <AfaMessageAnime title="No hi ha dades per mostrar." />
                    ) : null}
                  </Stack>
                )}
              </ContainerWhite>
            </Stack>
          </Grid.Col>

          <Grid.Col span={6}>
            {/* Columna derecha: Alerta + Comunicaciones del AFA */}
            <Stack gap="xs">
              <Flex justify="space-between" align="center">
                <Title order={3}>Últimes comunicacions</Title>
                <AfaButton
                  variant="outline"
                  size="sm"
                  onClick={() => navigate("/comunicaciones")}
                >
                  Veure-les totes
                </AfaButton>
              </Flex>
              <ContainerWhite style={{ height: "400px", overflowY: "auto" }}>
                {comunicacionsLoading ? (
                  <AfaSectionLoader message="Carregant últimes comunicacions..." />
                ) : (
                  <Stack gap="4px">
                    {comunicacionsData.length > 0 ? (
                      comunicacionsData.map((comm: any) => (
                        <AfaComunicacionsCard
                          key={comm.id || comm.title} // importante añadir una key única
                          title={comm.title}
                          description={comm.description}
                          data={moment(
                            comm.communicationDate.toString(),
                          ).format("DD/MM/YYYY")}
                          onClick={() => {
                            const encodedTitle = encodeURIComponent(comm.title);
                            navigate(`/comunicaciones/detall/${encodedTitle}`);
                          }}
                        />
                      ))
                    ) : (
                      // No hay filtros en esta sección, solo mostrar mensaje si BD está vacía
                      <AfaMessageAnime title="No hi ha dades per mostrar." />
                    )}
                  </Stack>
                )}
              </ContainerWhite>
            </Stack>
          </Grid.Col>
        </Grid>

        {props.user?.user.trameses && (
          <Stack gap="xs">
            <Flex justify="space-between" align="center">
              <Group gap="xs">
                <Title order={3}>Trameses recents</Title>
                <Tooltip
                  label="Aquesta és una visió simplificada i filtrada. Per veure totes les trameses, heu de fer clic al botó «Veure-les totes»."
                  multiline
                  w={300}
                  withArrow
                  position="top"
                >
                  <IconInfoCircle size={20} />
                </Tooltip>
              </Group>
              <Group gap="xs">
                <AfaButton
                  variant="outline"
                  size="sm"
                  onClick={() => navigate("/trameses/consultar")}
                >
                  Veure-les totes
                </AfaButton>
                <AfaButton
                  variant="filled"
                  size="sm"
                  onClick={() => navigate("/trameses/iniciar-nova")}
                >
                  Nova tramesa
                </AfaButton>
              </Group>
            </Flex>
            <ContainerWhite>
              <AfaTable
                columns={tramesesColumns}
                data={tramesesData}
                loading={tramesesLoading}
                loadingMessage="Carregant trameses recents..."
                emptyState={{
                  title: "No hi ha dades per mostrar.",
                }}
              />
            </ContainerWhite>
          </Stack>
        )}

        {props.user?.user.tramits && (
          <Stack gap="xs">
            <Flex justify="space-between" align="center">
              <Group gap="xs">
                <Title order={3}>Tràmits recents</Title>
                <Tooltip
                  label="Aquesta és una visió simplificada i filtrada. Per veure tots els tràmits, heu de fer clic al botó «Veure'ls tots»."
                  multiline
                  w={300}
                  withArrow
                  position="top"
                >
                  <IconInfoCircle size={20} />
                </Tooltip>
              </Group>
              <Group gap="xs">
                <AfaButton
                  variant="outline"
                  size="sm"
                  onClick={() => navigate("/tramits/consultar")}
                >
                  Veure'ls tots
                </AfaButton>
                <AfaButton
                  variant="filled"
                  size="sm"
                  onClick={() => navigate("/tramits/iniciar-nou")}
                >
                  Nou tràmit
                </AfaButton>
              </Group>
            </Flex>
            <ContainerWhite>
              <AfaTable
                columns={tramitsColumns}
                data={tramitsData}
                loading={tramitsLoading}
                loadingMessage="Carregant tràmits recents..."
                emptyState={{
                  title: "No hi ha dades per mostrar.",
                }}
              />
            </ContainerWhite>
          </Stack>
        )}
      </Stack>
      {/* Modal de Filtres */}
      {/* <AfaModal
        opened={filtresModalOpened}
        onClose={() => setFiltresModalOpened(false)}
        title="Filtres"
      >
        <Stack gap="md" mt="md">
          <AfaTextInput
            placeholder="Cerca aquí"
            value={searchText}
            onChange={(e) => setSearchText(e.target.value)}
          />

          <Grid gutter="md">
            <Grid.Col span={6}>
              <AfaDatePickerInput
                label="Data límit des de"
                value={dataLimitDes}
                onChange={setDataLimitDes}
              />
            </Grid.Col>
            <Grid.Col span={6}>
              <AfaDatePickerInput
                label="Fins a"
                value={dataLimitFins}
                onChange={setDataLimitFins}
              />
            </Grid.Col>
          </Grid>

          <Flex justify="flex-end" gap={16} mt="md">
            <AfaButton
              variant="outline"
              onClick={handleClearFilters}
            >
              Esborrar filtres
            </AfaButton>
            <AfaButton
              variant="filled"
              onClick={handleSearch}
            >
              Cercar
            </AfaButton>
          </Flex>
        </Stack>
      </AfaModal> */}

      <CancelTramitModal
        apiService={props.apiService}
        opened={cancelTramitModalOpened}
        onClose={(isSubmitting: boolean) => {
          if (isSubmitting) setTramitsLoading(true);
          setCancelTramitModalOpened(false);
        }}
        tramitId={selectedTramitId}
      />

      {/* Modal de cancelación */}
      <CancelTramesaModal
        apiService={props.apiService}
        opened={cancelModalOpened}
        onClose={(isSubmitting: boolean) => {
          if (isSubmitting) setTramesesLoading(true);
          setCancelModalOpened(false);
        }}
        // onClose={() => {
        //   setTramesesLoading(true);
        //   setCancelModalOpened(false);
        // }}
        tramesaId={selectedTramesaId}
      />
    </Stack>
  );
};

export default Dashboard;
